import {
  SET_DARK_MODE,
  SET_ACCOUNT
} from 'app/actions/types';

import {
  switchAccount as switchAccountSvc
} from 'app/services/portal';

export const setDarkMode = bool => dispatch => {
  dispatch({
    type: SET_DARK_MODE,
    payload: bool
  });
}

export const setAccount = account => dispatch => {
  dispatch({
    type: SET_ACCOUNT,
    payload: account
  });
}

export const switchAccount = accountId => async dispatch => {
  let params = {
    account_id: accountId
  }

  let account = await switchAccountSvc(params);

  dispatch({
    type: SET_ACCOUNT,
    payload: account
  });
}
